<template>
  <masked-input
    :value="value"
    :id="id"
    class="ui-masked-input"
    :class="{ 'ui-masked-input--error': error, 'ui-masked-input--disabled': disabled }"
    :placeholder="placeholder"
    :mask="{ pattern: mask }"
    :disabled="disabled"
    :type="type"
    @input="handleInput"
    @focus="handleFocus"
    @blur="$emit('blur')"
  />
</template>

<script>
export default {
  name: 'UiMaskedInput',
  emits: ['input', 'focus', 'blur'],
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    mask: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'text',
    },
    error: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      // isMounted: false,
      // isUserInteracted: false,
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.isMounted = true
    })
  },
  methods: {
    handleFocus(event) {
      // this.isUserInteracted = true
      this.$emit('focus', event)
    },
    handleInput(value) {
      // if (!this.isUserInteracted) {
      //   return
      // }

      this.$emit('input', value)
    },
  },
}
</script>

<style lang="sass">
@import "~@src/legacy/sass/params"

.ui-masked-input
  width: 100%
  min-height: 48px
  padding: 0 16px
  border: var(--field-border-width, 1px) solid var(--field-border-color, #C8C8C8)
  border-radius: 4px
  transition: border .2s

  &::placeholder
    color: var(--field-placeholder-color, $gray-text)

  &--error
    border: var(--field-error-border-width, 1px) solid var(--field-error-border-color, $error)

  &--disabled
    opacity: var(--field-opacity-disabled, 0.7)
    pointer-events: none
    background-color: var(--field-disabled-bg-color, #ededed)
</style>



// WEBPACK FOOTER //
// src/modules/shared/ui/public/forms/fields/UiMaskedInput.vue